<script setup lang="ts">
import useDomain from '@/composables/domainDependable';

const domain = useDomain();
</script>

<template>
    <stf-container>
        <div class="stf-banner__container my-3">
            <template v-if="domain.bannerImageUrl.length > 0">
                <img :src="domain.bannerImageUrl" width="100%" alt="banner" class="stf-banner__image">
            </template>
            <template v-else>
                <div class="stf-banner__text">Your application</div>
                <img src="/img/banner-new-app-process-xl.png" width="100%" alt="banner" class="stf-banner__image">
                <img src="/img/TM-Text-Logo-White-Thin.png" alt="TM Logo" class="stf-banner__logo">
            </template>
        </div>
    </stf-container>
</template>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-banner__container {
  position: relative;
}

.stf-banner__text {
  position: absolute;
  top: 40%;
  left: 25px;
  transform: translateY(-50%);
  color: white;
  font-size: vars.$font-size-64;
  font-weight: vars.$font-weight-semibold;
  z-index: 1;

  @include mixins.mobile {
    //display: none;
    top: 33%;
    left: 15px;
    font-size: vars.$font-size-20;
  }
}

.stf-banner__logo {
  position: absolute;
  bottom: 25px;
  left: 25px;
  z-index: 1;
  width: 256px;

  @include mixins.mobile {
    width: 120px;
    bottom: 15px;
    left: 15px;
  }
}

.stf-banner__image {
  border-radius: vars.$border-radius-desktop;

  @include mixins.mobile {
    border-radius: vars.$border-radius-mobile;
  }
}
</style>
